import React, { useEffect, useLayoutEffect, useRef } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AOS from "aos";
import Notfound from "./pages/Notfound";
import LandingOne from "./landing/LandingOne";
import CelebrationPage from "./pages/CelebrationPage";
import { scrollToHashTarget } from "./utils/scrollToHashTarget";

export default function App() {
  const location = useLocation();
  const prevPathnameRef = useRef(null);

  useEffect(() => {
    AOS.init({
      disable: () =>
        typeof window !== "undefined" && window.matchMedia
          ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
          : false,
    });
    AOS.refresh();
  }, []);

  // Scroll to top after a route change, or to the target hash element (accounting for the
  // fixed banner/header stack) when the route change carries one — e.g. /celebration-video/ -> /#contact.
  // Same-page hash clicks (pathname unchanged) are left to the browser's native anchor scrolling,
  // exactly as before this fix.
  useLayoutEffect(() => {
    const pathnameChanged = prevPathnameRef.current !== location.pathname;
    prevPathnameRef.current = location.pathname;

    if (!pathnameChanged) return;

    if (location.hash) {
      return scrollToHashTarget(location.hash.slice(1));
    }

    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingOne />} />
        <Route path="/celebration-video" element={<CelebrationPage />} />
        <Route path="*" element={<Notfound />} />
      </Routes>
    </>
  );
}
